export default __webpack_public_path__ + "static/media/logo.5e706b94.png";